import React, { useState } from 'react';

const QuickActionsMenu = ({ onOpenStats, onOpenHelp, onExportHistory, onNewRecovery }) => {
  const [isOpen, setIsOpen] = useState(false);

  const actions = [
    {
      id: 'stats',
      label: 'Статистика',
      icon: '📊',
      onClick: () => {
        onOpenStats();
        setIsOpen(false);
      },
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 'help',
      label: 'Справка',
      icon: '❓',
      onClick: () => {
        onOpenHelp();
        setIsOpen(false);
      },
      color: 'from-purple-500 to-purple-600'
    },
    {
      id: 'export',
      label: 'Экспорт',
      icon: '💾',
      onClick: () => {
        onExportHistory();
        setIsOpen(false);
      },
      color: 'from-green-500 to-green-600'
    },
    {
      id: 'new',
      label: 'Новый заказ',
      icon: '➕',
      onClick: () => {
        onNewRecovery();
        setIsOpen(false);
      },
      color: 'from-orange-500 to-orange-600'
    }
  ];

  return (
    <>
      {/* Floating Action Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed bottom-4 right-4 z-40 p-4 bg-gradient-to-br from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white rounded-full shadow-2xl transition-all duration-300 hover:scale-110 ${
          isOpen ? 'rotate-45' : ''
        }`}
        title="Быстрые действия"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
      </button>

      {/* Action Menu */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-20 z-30 animate-fade-in"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Actions */}
          <div className="fixed bottom-20 right-4 z-40 space-y-3 animate-scale-in">
            {actions.map((action, index) => (
              <div
                key={action.id}
                className="flex items-center gap-3 animate-slide-in-right"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <span className="text-sm font-medium text-gray-700 bg-white px-3 py-1 rounded-lg shadow-md">
                  {action.label}
                </span>
                <button
                  onClick={action.onClick}
                  className={`p-3 bg-gradient-to-br ${action.color} text-white rounded-full shadow-lg hover:scale-110 transition-transform`}
                  title={action.label}
                >
                  <span className="text-xl">{action.icon}</span>
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default QuickActionsMenu;










